import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './tabs.component';
import { BeforeActivationModule } from '../../before-activation/before-activation.module';
import { TranslateModule } from '@ngx-translate/core';
import { DebounceDirectiveModule } from 'src/app/angular-wallet-base/directives/debounce/debounce-directive.module';

@NgModule({
  declarations: [TabsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    BeforeActivationModule,
    DebounceDirectiveModule
  ],
  exports: [TabsComponent]
})
export class TabsModule { }
